// src/utils/pressePapier.ts — SCE Issues
// Coller une photo ou un fichier (09/10), directement dans le champ de
// commentaire ou de description : capture d'écran (Outil Capture, Win+Maj+S,
// Greenshot…) ou fichier copié depuis l'explorateur.
//
// Deux pièges :
//  - un texte copié depuis Word, Excel ou Outlook arrive AUSSI avec une image
//    de ce texte. Dès qu'il y a du texte, on colle le texte, pas l'image ;
//  - une capture arrive toujours nommée « image.png » : on lui donne un nom
//    daté, pour qu'on s'y retrouve dans SharePoint.

/** Le collage contient-il des fichiers à joindre (et non du texte) ? */
export function fichiersColles(donnees: DataTransfer | null, maintenant = new Date()): File[] {
  if (!donnees) return []
  const fichiers: File[] = []
  for (const f of Array.from(donnees.files ?? [])) fichiers.push(f)
  // Certains navigateurs ne remplissent que `items`.
  if (fichiers.length === 0) {
    for (const item of Array.from(donnees.items ?? [])) {
      if (item.kind !== 'file') continue
      const f = item.getAsFile()
      if (f) fichiers.push(f)
    }
  }
  if (fichiers.length === 0) return []

  const texte = donnees.getData('text/plain').trim()
  const queDesImages = fichiers.every((f) => f.type.startsWith('image/'))
  if (texte && queDesImages) return []

  return fichiers.map((f, i) => {
    const nom = nomColle(f.name, f.type, maintenant, fichiers.length > 1 ? i + 1 : 0)
    return nom === f.name ? f : new File([f], nom, { type: f.type, lastModified: f.lastModified })
  })
}

/** « image.png » (ou sans nom) → « capture-20261009-143012.png » ; un vrai nom est gardé. */
export function nomColle(nom: string, type: string, date: Date, rang = 0): string {
  if (nom && !/^image\.\w+$/i.test(nom)) return nom
  const ext = /\.(\w+)$/.exec(nom)?.[1]?.toLowerCase() ?? type.split('/')[1]?.replace('jpeg', 'jpg') ?? 'png'
  const p = (n: number): string => String(n).padStart(2, '0')
  const horodatage = `${date.getFullYear()}${p(date.getMonth() + 1)}${p(date.getDate())}-${p(date.getHours())}${p(date.getMinutes())}${p(date.getSeconds())}`
  return `capture-${horodatage}${rang ? `-${rang}` : ''}.${ext}`
}
